import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { PartnerReportTypeKey } from '@nk/data-entities-lib';

export interface AbstractReportState {
  error: HttpErrorResponse | null;
  isLoading: boolean;
  isReady: boolean;
}

/**
 * @param updateReportState - EventEmitter which emits report's state updates
 */
export interface AbstractReport {
  updateReportState: EventEmitter<AbstractReportState>;
}

export type PartnerReportEntityKey = 'company' | 'property';

export interface FileMetaItem {
  label: string;
  filePathWithoutSession: string;
}

export const PARTNER_REPORT_TYPE_KEY_TRANSLATIONS: Record<PartnerReportTypeKey, string> = {
  [PartnerReportTypeKey.brreg_company_bankruptcy_report]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_bankruptcy_report',
  ),
  [PartnerReportTypeKey.brreg_company_certificate]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_certificate',
  ),
  [PartnerReportTypeKey.brreg_company_collateral_report]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_collateral_report',
  ),
  [PartnerReportTypeKey.brreg_company_name_report]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_name_report',
  ),
  [PartnerReportTypeKey.brreg_company_registry_report]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_registry_report',
  ),
  [PartnerReportTypeKey.brreg_company_role_report]: extractTranslation(
    'partner_report_card.partner_report_type.brreg_company_role_report',
  ),
  [PartnerReportTypeKey.creditsafe_json_company_report]: extractTranslation('partner_report_card.download_report'),
  [PartnerReportTypeKey.creditsafe_pdf_company_report]: extractTranslation('partner_report_card.download_report'),
  [PartnerReportTypeKey.mock_report]: extractTranslation('partner_report_card.download_report'),
  [PartnerReportTypeKey.no_kartverket_grunnbokutskrift_report]: extractTranslation(
    'property.property_report.report_type_label.grunnbokutskrift',
  ),
};
